import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { preferenceValueData, getPreferenceRes, updatePreferenceRes } from "../../components/settings/preferenceSettings/preferenceSettingModule";

import { ZenToast } from "zen-core-elements";

interface initialState {
    loading: boolean
    getPreference: preferenceValueData | null

}
const initialState: initialState = {
    loading: false,
    getPreference: null
}

export const getPreference = createAsyncThunk("preference/getPreferenceValues", ({ storeId }: { storeId: number }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getPreferenceValues, { storeId: storeId })
    return HttpRoutingService?.getMethod<getPreferenceRes>(url)
})
export const updatePreference = createAsyncThunk("preference/updatePreferenceValues", ({ storeId, data }: { storeId: number, data: preferenceValueData }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getPreferenceValues, { storeId: storeId })
    return HttpRoutingService?.putMethod<updatePreferenceRes>(url, data, {}, "v2/")
})

export const preferenceSettingSlice = createSlice({
    name: "preference",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPreference?.pending, (state) => {
                state.loading = true
            })
            .addCase(getPreference?.fulfilled, (state, action) => {
                state.loading = false
                state.getPreference = action.payload?.preferenceValueData[0]
            })
            .addCase(getPreference?.rejected, (state) => {
                state.loading = false
                ZenToast({
                    type: "error",
                    message: "Failed to get a preference data, Please try again after some time!"
                })
            })
            .addCase(updatePreference?.pending, (state) => {
                state.loading = true
            })
    }
})

export default preferenceSettingSlice?.reducer